import Navbar from "../component/common/Navbar";
import Footer from "../component/common/Footer";
import PageHero from "../component/common/PageHero";
import AllCourses from "../component/courses/AllCourses";

const Courses = () => {
  return (
    <div>
      <Navbar />
      <PageHero title="Courses" />
      <div className="section"></div>
      <AllCourses />
      <Footer />
    </div>
  );
};
export default Courses;
